<template>
  <div id="login" v-if="$route.path === '/login'" class="login-warpper">
      <div class="user-banner">
          <div class="img-warpper"><img src="../../assets/loginBg.png" alt=""></div>
          <div class="mod2-box">
                <div class="mod-list logo"><img src="../../assets/3DPPT_LOGO_WHITE.png" alt=""></div>
          </div>
          <div class="mod3-box">
                <div class="mod-list"><h2>恒点互动演示大师</h2></div>
                <div class="mod-list"><p>恒点互动演示大师 ，距离心仪的演示文稿只有一步之遥！</p></div>
          </div>
      </div>

      <div class="user-box mod-list1">

        <div class="mod-fix-warpper mod-item" v-if="!resetPwdFlag" :class="{'warpper-fix-register': showGraphicCode1 && operateType}">
            <div class="toggle-box mod-item" >
                <span class="user-title" :class="{'active': !operateType}" @click="toggleHandler">登录</span>
                <span class="user-title" :class="{'active': operateType}" @click="toggleHandler">注册</span>
            </div>
            <div class="mod-fix1" >
                <div class="login-part link" :class="{'active': operateType}">
                    <el-form :model="loginModel" ref="loginModel" :rules="loginForm"  class="demo-ruleForm">
                        <div class="login-box-fix1">
                            <el-form-item  prop="mobile">
                                <el-input  v-model="loginModel.mobile" autocomplete="off" placeholder="手机号">
                                </el-input>
                            </el-form-item>
                            <el-form-item  prop="password" v-if="!isMsgLogin">
                                <el-input :type="dynamicType" v-model="loginModel.password" autocomplete="off"  placeholder="密码">
                                </el-input>
                                <i class="pwd-icon" :class="{'pwd-icon1':showPwdFlag}" @click="changeInputType"></i>
                            </el-form-item>
                            <el-form-item  prop="code" v-if = isMsgLogin>
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text" v-model.number="loginModel.code" autocomplete="off"  placeholder="短信验证码">
                                        </el-input>
                                    </div>
                                    <div class="mod-item">
                                        <el-button type="primary" :loading="isSendedMsg" v-text="msgObj.content" @click="getMsgCode"></el-button>
                                    </div>
                                </div>

                            </el-form-item>
                            <el-form-item  prop="captcha" v-if="showGraphicCode">
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text" v-model="loginModel.captcha" autocomplete="off"  placeholder="验证码">
                                        </el-input>

                                    </div>
                                    <div class="mod-item">
                                        <span class="v-code-img"><img :src="captcha"></span>
                                        <i class="el-icon-refresh-right" @click="refreshGrahpic"></i>
                                    </div>
                                </div>

                            </el-form-item>
                        </div>
                        <el-form-item style="margin-top: 78px;margin-bottom: 0" class="spe-btn-box">
                            <el-button type="primary" style="width:100%" @click="submitForm(1)"  id="JLoginBtn">登录</el-button>
                        </el-form-item>
                        <el-form-item class="mod4-list">
                            <span @click="changeLoginType">{{isMsgLogin ? '密码登录' : '短信登录'}}</span>
                            <span></span>
                            <span @click="toResetPwdHandler">忘记密码</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="register-part link" :class="{'active': operateType}">
                    <el-form :model="loginModel1" ref="loginModel1" :rules="registerForm"  class="demo-ruleForm">
                        <div class="register-fix-box1">
                            <el-form-item  prop="mobile">
                                <el-input  v-model="loginModel1.mobile" autocomplete="off" placeholder="手机号">
                                </el-input>
                            </el-form-item>
                            <el-form-item  prop="password">
                                <el-input :type="dynamicType1"
                                    v-model="loginModel1.password"
                                    autocomplete="off"
                                    placeholder="密码（6-20位，数字、大小写字母组合）">
                                </el-input>
                                <i class="pwd-icon" :class="{'pwd-icon1':showPwdFlag1}" @click="changeInputType1"></i>
                            </el-form-item>
                            <el-form-item  prop="code">
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text" v-model.number="loginModel1.code" autocomplete="off"  placeholder="短信验证码">
                                        </el-input>
                                    </div>
                                    <div class="mod-item">
                                        <el-button type="primary" :loading="isSendedMsg1" v-text="msgObj1.content" @click="getMsgCode1"></el-button>
                                    </div>
                                </div>

                            </el-form-item>
                            <el-form-item  prop="captcha" v-if ="showGraphicCode1">
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text" v-model="loginModel1.captcha" autocomplete="off"  placeholder="验证码">
                                        </el-input>

                                    </div>
                                    <div class="mod-item">
                                        <span class="v-code-img"><img :src="captcha"></span>
                                        <i class="el-icon-refresh-right" @click="refreshGrahpic"></i>
                                    </div>
                                </div>

                            </el-form-item>
                        </div>
                        <el-form-item style="margin-top: 78px;margin-bottom: 0" class="spe-btn-box">
                            <div> <el-checkbox v-model="agreeChecked">已阅读并同意以下协议</el-checkbox><b class="agree-link">《平台服务协议》</b></div>
                            <el-button type="primary" style="width:100%" @click="submitForm(2)"  id="JLoginBtn">注册</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="mod-fix-warpper mod-item" v-if="resetPwdFlag">
            <div class="toggle-box mod-item" >
                <span class="mod-title1">密码重置</span>
            </div>
            <div class="mod-fix1" >
                <div class="login-part link active">
                    <el-form :model="loginModel2" ref="loginModel2"  :rules="loginForm2"  class="demo-ruleForm">
                        <div class="login-box-fix1" v-if="!setNewPwdFlag">
                            <el-form-item  prop="mobile">
                                <el-input  v-model="loginModel2.mobile" autocomplete="off" placeholder="手机号">
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="code">
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text"  v-model.number="loginModel2.code" autocomplete="off"  placeholder="短信验证码">
                                        </el-input>
                                    </div>
                                    <div class="mod-item">
                                        <el-button type="primary" :loading="isSendedMsg" v-text="msgObj.content" @click="getMsgCode2"></el-button>
                                    </div>
                                </div>

                            </el-form-item>
                            <el-form-item  prop="captcha" v-if="showGraphicCode2">
                                <div class="mod5-list">
                                    <div class="mod-item">
                                        <el-input type="text" v-model="loginModel2.captcha" autocomplete="off"  placeholder="验证码">
                                        </el-input>

                                    </div>
                                    <div class="mod-item">
                                        <span class="v-code-img"><img :src="captcha1"></span>
                                        <i class="el-icon-refresh-right" @click="refreshGrahpic"></i>
                                    </div>
                                </div>

                            </el-form-item>
                        </div>
                        <div class="login-box-fix1" v-if="setNewPwdFlag">
                            <el-form-item  prop="password" >
                                <el-input :type="dynamicType3" v-model="loginModel2.password" autocomplete="off"  placeholder="新密码">
                                </el-input>
                                <i class="pwd-icon" :class="{'pwd-icon1':loginModel2.pwdFlag1}" @click="changeInputTypeHandler(loginModel2,'pwdFlag1')"></i>
                            </el-form-item>
                            <el-form-item  prop="cPassword" >
                                <el-input :type="dynamicType4" v-model="loginModel2.cPassword" autocomplete="off"  placeholder="确认新密码">
                                </el-input>
                                <i class="pwd-icon" :class="{'pwd-icon1':loginModel2.pwdFlag2}" @click="changeInputTypeHandler(loginModel2,'pwdFlag2')"></i>
                            </el-form-item>
                        </div>
                        <el-form-item style="margin-top: 78px;margin-bottom: 0" class="spe-btn-box">
                            <el-button type="primary" style="width:100%" @click="submitForm(3)"  id="JLoginBtn">下一步</el-button>
                        </el-form-item>
                        <el-form-item class="mod4-list">
                            <span @click="backToLogin">返回登录</span>
                        </el-form-item>

                    </el-form>
                </div>

            </div>
        </div>
        <div class="mod-list2">
            <div class="mod-item spe-item2">
                <div class="mod-link">

                    <p><b class="spe-links-info"><a href="https://beian.miit.gov.cn" target="_blank">苏ICP备16057523号-9 </a>
                        </b><a href="http://beian.gov.cn/portal/registerSystemInfo?recordcode=32011302320926" target="_blank">
                        <img src="http://static.hdmool.com/images/gongan.png" /> <b> 苏公网安备 32011302320926号</b></a></p>

                </div>

            </div>
        </div>

      </div>

        <el-dialog
            title="提示"
            :visible.sync="agreeDialogVisible"
            width="60%"
            :before-close="handleClose">
            <div></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {doLogin, getPublickKey, isRequireGraphic, getSms, doRegister, doLoginByMsg, resetPwd} from '@/api'
import {JSEncrypt} from 'jsencrypt'
import {_isNumber, getUrlParam} from '../../utils/index'
// import {mapActions, mapState} from 'vuex'
// import ws from '../../dist/websocket'
export default {
    name: 'login',
    emit: ['', ''],
    props: {

    },
    data () {
        const validateMobile = (rule, value, callback) => {
            const mobileReg = /^1[3456789]\d{9}$/

            if (!mobileReg.test(value)) {
                callback(new Error('请输入正确手机号'))
            } else {
                callback()
            }
        }

        const validatePwd = (rule, value, callback) => {
            const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
            if (!pwdReg.test(value)) {
                // callback()
                callback(new Error('请输入符合规则的密码！'))
            } else {
                callback()
                // callback(new Error('密码格式错误，支持6-20位，数字和大小写字母组合。'))
            }
        }
        const validatePwd1 = (rule, value, callback) => {
            const pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
            // 处理切换到忘记密码自动校验密码输入框问题
            if (!this.setNewPwdFlag) {
                callback()
                return
            }
            if (!pwdReg.test(value)) {
                // callback()
                callback(new Error('请输入符合规则的密码！'))
            } else {
                callback()
                // callback(new Error('密码格式错误，支持6-20位，数字和大小写字母组合。'))
            }
        }
        const validateCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入短信验证码'))
                return
            }
            if (!_isNumber(value)) {
                callback(new Error('验证码格式错误，短信验证码为6位数字'))
                return
            }
            callback()
        }
        // const validateCode1 = (rule, value, callback) => {
        //     // 重置密码用
        //     if (!this.isSendedMsg) {
        //         callback()
        //         return
        //     }
        //     if (!value) {
        //         callback(new Error('请输入短信验证码'))
        //         return
        //     }
        //     if (!_isNumber(value)) {
        //         callback(new Error('验证码格式错误，短信验证码为6位数字'))
        //         return
        //     }
        //     callback()
        // }
        return {

            loginForm: {
                mobile: [
                    { validator: validateMobile, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePwd, trigger: 'blur' }
                ],
                code: [
                    { validator: validateCode, trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入图形验证码', trigger: 'blur' }
                ]
            },
            loginForm2: {
                mobile: [
                    { validator: validateMobile, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePwd1, trigger: 'blur' }
                ],
                code: [
                    { validator: validateCode, trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入图形验证码', trigger: 'blur' }
                ]
            }, // 忘记密码用

            loginModel: {
                mobile: '',
                captcha: '',
                password: '',
                code: ''
            },
            loginModel1: {
                mobile: '',
                captcha: '',
                password: '',
                code: ''
            },
            loginModel2: {
                mobile: '',
                captcha: '',
                code: '',
                password: '',
                pwdFlag1: false,
                pwdFlag2: false
            },
            registerForm: {
                mobile: [
                    { validator: validateMobile, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePwd, trigger: 'blur' }
                ],
                code: [
                    { validator: validateCode, trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入图形验证码', trigger: 'blur' }
                ]
            },
            registerModel: {
                username: '',
                password: ''
            },
            loginInfoStoreStatus: false,
            loginInfo: null,
            showPwdFlag: 0,
            cutDown: 0,
            operateType: 0, // 0 登录 1 注册
            msgObj: {
                content: '获取验证码',
                type: 'primary'
            },
            msgObj1: {
                content: '获取验证码',
                type: 'primary'
            },
            isSendedMsg: false,
            isSendedMsg1: false,
            showGraphicCode: false,
            showMsgCode: false,
            agreeChecked: false,
            agreeDialogVisible: false,
            showGraphicCode1: false,
            showGraphicCode2: false, // 忘记密码
            // showMsgCode1: ture,
            isMsgLogin: false, // 使用短信验证码登录
            captchaTime: new Date().getTime(),
            showPwdFlag1: false,
            resetPwdFlag: false,
            setNewPwdFlag: false
        }
    },
    computed: {
        // ...mapState({
        //     moduleAMsg: (state) => state.moduleA.msg
        // })
        captchaType () {
            if (this.resetPwdFlag) {
                return 'reset'
            }
            if (!this.operateType && this.isMsgLogin) {
                return 'smsLogin'
            }
            if (!this.operateType && !this.isMsgLogin) {
                return 'pwdLogin'
            }
            if (this.operateType) {
                return 'reg'
            }

            // return this.operateType === 0 ? this.isMsgLogin ? 'smsLogin' : 'pwdLogin' : 'reg'
        },
        captcha () {
            return '/api/v1/captcha?type=' + this.captchaType + '&timeamp=' + this.captchaTime
        },
        // 密码重置专用
        captcha1 () {
            return '/api/v1/captcha?type=reset&timeamp=' + this.captchaTime
        },
        dynamicType () {
            return this.showPwdFlag ? 'text' : 'password'
        },
        dynamicType1 () {
            return this.showPwdFlag1 ? 'text' : 'password'
        },
        dynamicType3 () {
            // 重置密码用
            return this.loginModel2.pwdFlag1 ? 'text' : 'password'
        },
        dynamicType4 () {
            // 重置密码用
            return this.loginModel2.pwdFlag2 ? 'text' : 'password'
        }
    },
    mounted () {
        this.operateType = 0
        this.graphicHandler('pwdLogin')
    },
    methods: {
        validateSimple (formName, rule) {
            this.$refs[formName].validateField(rule, (info) => {
                console.log(info)
            })
        },
        backToLogin () {
            this.resetPwdFlag = false
            this.isMsgLogin = false
            this.operateType = 0
            this.graphicHandler('pwdLogin')
            this.$nextTick(() => {
                this.$refs.loginModel.resetFields()
            })
        },
        toResetPwdHandler () {
            this.resetPwdFlag = true
            this.graphicHandler('reset')
            this.$nextTick(() => {
                this.$refs.loginModel2.clearValidate()
            })
        },
        toLogin () {},
        changeInputTypeHandler (list, key) {
            list[key] = !list[key]
        },
        formateMsgParam (obj) {
            const cData = JSON.parse(JSON.stringify(obj))
            delete cData.password
            delete cData.captcha
            return cData
        },
        getMsgCode () {
            this.$refs.loginModel && this.$refs.loginModel.validateField('mobile', (valid) => {
                if (!valid) {
                    getSms(this.formateMsgParam({
                        ...this.loginModel,
                        type: this.captchaType,
                        captcha: this.captcha
                    })).then(res => {
                        if (res) {
                            if (res.code !== undefined && res.code === 412) {
                                this.$refs['loginModel1'].resetFields()
                                this.$message({type: 'error', message: '该手机号未注册，请先注册', duration: 5000})
                                this.operateType = 1
                                this.loginModel1.mobile = this.loginModel.mobile
                                this.graphicHandler(this.captchaType)
                                return
                            }
                            // 获取短信验证码成功
                            this.isSendedMsg = true
                            let num = 60
                            this.msgObj.content = num + 's'
                            const loop = () => {
                                setTimeout(() => {
                                    num--
                                    this.msgObj.content = num + 's'
                                    if (num > 0) {
                                        loop()
                                    } else {
                                        this.isSendedMsg = false
                                        this.msgObj.content = '获取验证码'
                                    }
                                }, 1000)
                            }
                            loop()
                        } else {
                            this.captchaTime = new Date().getTime()
                        }
                        this.graphicHandler(this.captchaType)
                    })
                }
            })
        },
        getMsgCode1 () {
            this.$refs.loginModel1 && this.$refs.loginModel1.validateField('mobile', (valid) => {
                if (!valid) {
                    getSms(this.formateMsgParam({
                        ...this.loginModel1,
                        type: this.captchaType,
                        captcha: this.captcha
                    })).then(res => {
                        if (res) {
                            if (res.code !== undefined && res.code === 411) {
                                this.$refs['loginModel'].resetFields()
                                this.loginModel.mobile = this.loginModel1.mobile
                                this.$message({type: 'error', message: '该手机号已注册，可直接登录', duration: 5000})
                                this.operateType = 0
                                this.graphicHandler(this.captchaType)
                                return
                            }
                            // 获取短信验证码成功
                            this.isSendedMsg1 = true
                            let num = 60
                            this.msgObj1.content = num + 's'
                            const loop = () => {
                                setTimeout(() => {
                                    num--
                                    this.msgObj1.content = num + 's'
                                    if (num > 0) {
                                        loop()
                                    } else {
                                        this.isSendedMsg1 = false
                                        this.msgObj1.content = '获取验证码'
                                    }
                                }, 1000)
                            }
                            loop()
                        } else {
                            this.captchaTime = new Date().getTime()
                        }
                        this.graphicHandler(this.captchaType)
                    })
                }
            })
        },
        getMsgCode2 () {
            // 重置密码验证码
            this.$refs.loginModel2 && this.$refs.loginModel2.validateField('mobile', (info) => {
                if (!info) {
                    getSms({
                        ...this.loginModel2,
                        type: 'reset'
                    }).then(res => {
                        if (res) {
                            if (res.code !== undefined && res.code === 412) {
                                this.$message({type: 'error', message: '该手机号未注册，请先注册'})
                                return
                            }
                            // 获取短信验证码成功
                            this.isSendedMsg = true
                            let num = 60
                            this.msgObj.content = num + 's'
                            const loop = () => {
                                setTimeout(() => {
                                    num--
                                    this.msgObj.content = num + 's'
                                    if (num > 0) {
                                        loop()
                                    } else {
                                        this.isSendedMsg = false
                                        this.msgObj.content = '获取验证码'
                                    }
                                }, 1000)
                            }
                            loop()
                        } else {
                            this.captchaTime = new Date().getTime()
                        }
                        this.graphicHandler('reset')
                    })
                }
            })
            // this.$refs.loginModel2 && this.$refs.loginModel2.validate(async (valid) => {

            // })
        },
        changeLoginType () {
            // 改变登录方式
            this.isMsgLogin = !this.isMsgLogin
            this.graphicHandler(this.captchaType)
        },
        async graphicHandler (type) {
            const res = await isRequireGraphic({
                type
            })
            if (type === 'reg') {
                this.showGraphicCode1 = res
            }
            if (type === 'pwdLogin' || type === 'smsLogin') {
                this.showGraphicCode = res
            }
            if (type === 'reset') {
                this.showGraphicCode2 = res
            }
            // if (type === 'reset') {
            //     this.captchaType = 'reset'
            // }
            if (!res) {
                return
            }
            this.refreshGrahpic()

            // if (this.showGraphicCode) {
            //     getCaptcha({type: 'pwdLogin'}).then(res => {
            //         console.log(res)
            //     })
            // }
        },
        refreshGrahpic () {
            this.captchaTime = new Date().getTime()
        },
        submitForm (type) {
            // type 1 登录  type 2 注册 3 重置密码
            if (type === 1) {
                this.$refs.loginModel && this.$refs.loginModel.validate(async (valid) => {
                    if (valid) {
                        const JSE = new JSEncrypt()
                        getPublickKey().then(async (res) => {
                            if (!res) {
                                this.$message({type: 'error', message: '获取签名失败'})
                                return
                            }
                            this.publicKey = res.key
                            JSE.setPublicKey(this.publicKey)
                            const loginInfo = {
                                ...this.loginModel,
                                ...{password: JSE.encrypt(this.loginModel.password)}
                            }
                            const userInfo = this.isMsgLogin ? await doLoginByMsg(loginInfo) : await doLogin(loginInfo)
                            if (!userInfo) {
                                // this.$message({type: 'error', message: userInfo.msg})
                                localStorage.removeItem('HD_PTM_USERINFO')
                                this.graphicHandler(this.captchaType)
                                return
                            }
                            if (userInfo) {
                                localStorage.setItem('HD_PTM_USERINFO', JSON.stringify(userInfo.user))
                                this.$message({type: 'success', message: '登录成功'})
                                setTimeout(() => {
                                    location.href = getUrlParam('', 'backUrl') ? getUrlParam('', 'backUrl') : location.origin
                                }, 500)
                            }
                            //
                        })
                    }
                })
            }
            if (type === 2) {
                this.$refs.loginModel1 && this.$refs.loginModel1.validate(async (valid) => {
                    if (valid) {
                        if (!this.agreeChecked) {
                            this.$message.closeAll()
                            this.$message({
                                type: 'error',
                                message: '请阅读并同意《恒点互动演示大师终端用户协议》！'
                            })
                            return
                        }
                        const JSE = new JSEncrypt()
                        getPublickKey().then(async (res) => {
                            if (!res) {
                                this.$message({type: 'error', message: '获取签名失败'})
                                return
                            }
                            this.publicKey = res.key
                            JSE.setPublicKey(this.publicKey)
                            const loginInfo = {
                                ...this.loginModel1,
                                ...{password: JSE.encrypt(this.loginModel1.password)}
                            }
                            const userInfo = await doRegister(loginInfo)

                            if (userInfo && userInfo.code !== undefined && userInfo.code === 411) {
                                this.$refs['loginModel'].resetFields()
                                this.loginModel.mobile = this.loginModel1.mobile
                                this.$message({type: 'error', message: '该手机号已注册，可直接登录', duration: 5000})
                                this.operateType = 0
                                this.graphicHandler(this.captchaType)
                                return
                            }
                            if (!userInfo) {
                                this.graphicHandler(this.captchaType)
                                localStorage.removeItem('HD_PTM_USERINFO')
                            }
                            if (userInfo) {
                                localStorage.setItem('HD_PTM_USERINFO', JSON.stringify(userInfo.user))
                                this.$message({type: 'success', message: '已注册成功'})
                                setTimeout(() => {
                                    location.href = location.origin
                                }, 500)
                            }
                        })
                    }
                })
            }
            if (type === 3) {
                if (this.setNewPwdFlag) {
                    const JSE = new JSEncrypt()
                    getPublickKey().then(async (res) => {
                        if (!res) {
                            this.$message({type: 'error', message: '获取签名失败'})
                            return
                        }
                        this.publicKey = res.key
                        JSE.setPublicKey(this.publicKey)
                        const loginInfo = {
                            ...this.loginModel2,
                            password: JSE.encrypt(this.loginModel2.password)
                        }
                        const resetPwdRes = await resetPwd(loginInfo)
                        if (resetPwdRes) {
                            this.$message({
                                type: 'success',
                                message: '密码重置成功'
                            })
                            // this.$refs.loginModel2.clearValidate()

                            this.setNewPwdFlag = false
                            this.resetPwdFlag = false
                            this.loginModel.mobile = this.loginModel2.mobile
                            // 解决自动校验登录密码问题
                            // setTimeout(() => {
                            //     this.$refs.loginModel.clearValidate()
                            // }, 20)
                            this.$nextTick(() => {
                                this.$refs.loginModel.clearValidate()
                            })
                        }
                        //
                    })
                } else {
                    resetPwd(this.loginModel2).then(res => {
                        if (res) {
                            this.setNewPwdFlag = true
                        }
                    })
                }
                // this.setNewPwdFlag = !this.setNewPwdFlag
            }
            // 临时处理无图形验证码
            let _this = this
            console.log(_this.captchaType)
            setTimeout(function () {
                _this.graphicHandler(_this.captchaType)
            }, 500)
        },
        toggleHandler () {
            // 切换登录注册
            this.operateType = !this.operateType
            this.graphicHandler(this.captchaType)
        },
        changeInputType () {
            this.showPwdFlag = !this.showPwdFlag
        },
        changeInputType1 () {
            this.showPwdFlag1 = !this.showPwdFlag1
        },
        handleClose () {}
        // ...mapActions({
        //     changeModuleAMsg: 'moduleA/changeModuleAMsgAction'
        // })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .login-warpper{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: relative;
    }
   .user-banner{
       position: relative;
       flex: 1;
       height: 100%;
        overflow: hidden;
    //    background: linear-gradient(180deg, #6aEEff 0% #00B1e5 84%, #07a7d6 100%);
   }
   .img-warpper{
     display: flex;
     align-items: center;
   }
   .user-box{
        flex:1.258;
        display: flex;
        justify-content: center;
        position: relative;
        align-items: center;
        .el-form-item{
            margin-bottom: 30px;
        }
        height: 100%;

   }
   .mod-fix-warpper{
       position: relative;
        width: 470px;
        height: 504px;
        box-shadow:
       0px 12px 48px 16px rgba($color: #000000, $alpha: .03),
       0 9px 28px 0 rgba($color: #000000, $alpha: 0.05),
       0 6px 16px -8px rgba($color: #000000, $alpha: .08);
       padding:  50px 75px;
       overflow: hidden;
   }
   .mod-fix1{
       position: relative;
       width: 100%;
       height: 100%;
       overflow: hidden;
   }
   .mod-list1 .link{
       position: absolute;
       width: 320px;
       left: calc(50% - 160px);
       top:43px;
       transition: all .5s;
   }
    .mod-list1 .link.active:first-child{
        left: calc(50% - 480px)
    }
    .mod-list1 .link.active:last-child{
        left: calc(50% - 160px) !important
    }
   .mod-list1 .link:last-child{
       position: absolute;
       left: 100%;
   }
   .toggle-box{
       color: #9b9b90;
       text-align: center;
       .user-title:first-child{
           margin-right: 60px;
       }
       .user-title{
           cursor: pointer;
           font-size: 24px;
       }
        .active{
           color: #4a4a4a;
           padding-bottom: 5px;
           border-bottom: 4px solid #00a4e0;
       }

   }
   .mod-list2{
       position:absolute;
       bottom: 20px;
       left: 0;
       width: 100%;
       text-align: center;
       font-size: 14px;
       color:#9b9b9b;
    a{
       color:#9b9b9b
    }
   }
   .mod2-box{
       width:100%;
       position: absolute;
       padding-top: 40px;
       padding-left: 40px;
        left: 0;
        top:0;
        .logo{
            width: 60px
        }
        img{
            width: 100%;
        }
   }
   .mod3-box{
    width:100%;
    position: absolute;
    left: 0;
    top:176px;
    color:#fff;
    text-align: center;
    h2{
        font-size: 32px;
    }
    .mod-list:last-child{
        margin-top: 48px;
        font-size: 20px;
    }
   }
   .pwd-icon{
       position: absolute;
       right:15px ;
       top: 10px;
       width: 20px;
       height: 20px;
       cursor: pointer;
       background: url('../../assets/icon_eye_close.svg') no-repeat;
   }
   .pwd-icon1{
    background: url('../../assets/icon_eye_open.svg') no-repeat;
   }
   .mod4-list {
       text-align: center;
       margin-top: 5px;
       span{
           display: inline-block;
            vertical-align: middle;
           margin-right: 10px;
           color: #9b9b9b;
           cursor: pointer;
       }
       span:hover{
           color: #00a4e0;
       }
       span:nth-child(2){
           width: 1px;
           background: #DCDCDC;
           height: 23px;
           margin: 0 10px 0 0;

       }
   }

   .agree-link{
       color: #00a4e0;
   }
   .warpper-fix-register {
       height: 574px;
   }
   .eleHidden {
       visibility: hidden;
   }
   .login-box-fix1{
       min-height: 181px;
   }
   .register-fix-box1{
       min-height: 141px;
   }
   .mod-title1{
       color: #4b4b4b;
       font-size:24px;
   }
    .to-login-btn{
       color: #9b9b9b;
    }

</style>



// WEBPACK FOOTER //
// src/components/business/login-part.vue